/** Kuma incidents are one free-text body; render it as paragraphs, no markdown engine. */
export function incidentParagraphs(content: string): string[] {
  return content.split(/\n\s*\n/).map((p) => p.trim()).filter(Boolean);
}

/** Kuma incident styles: info · warning · danger · primary · light · dark. */
export function incidentTone(style: string): string {
  switch (style) {
    case 'danger':
      return '#d0312d';
    case 'warning':
      return 'var(--color-data-amber)';
    case 'info':
    case 'primary':
      return 'var(--color-data-blue)';
    default:
      return 'var(--color-dim)';
  }
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const pad2 = (n: number) => String(n).padStart(2, '0');

/** Deterministic UTC "04 Sep 2026" — no `toLocale*` (locale-dependent ICU
 *  output, e.g. en-GB short months rendering "Sept", breaks fixed-width
 *  slicing downstream). Invalid input passes through unchanged. */
export function fmtDay(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return `${pad2(d.getUTCDate())} ${MONTHS[d.getUTCMonth()]} ${d.getUTCFullYear()}`;
}

/** Deterministic UTC "04 Sep 2026, 14:30 UTC". Invalid input passes through unchanged. */
export function fmtDate(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return `${fmtDay(iso)}, ${pad2(d.getUTCHours())}:${pad2(d.getUTCMinutes())} UTC`;
}
